import * as React from 'react';
import {FormComponentProps} from "antd/lib/form";
import {Form} from "antd";
import * as moment from 'moment';
import locales from "../locales";
import SubmitCancelFormItem from "../common/form-items/SubmitCancelFormItem";
import DatePickerFormItem from "../common/form-items/DatePickerFormItem";
import {MOMENT_DATE_FORMAT} from "../utils/date-utils";

const FIELD_HANDLED_DATE = 'handledDate';

interface Props extends FormComponentProps {
  onFormSubmit: (handledDate: string) => void;
  onFormCancel: () => void;
}

class HandleAlertsForm extends React.Component<Props, {}> {

  public render() {
    const {form} = this.props;
    const handledDate = moment();

    return (
      <Form>
        <DatePickerFormItem
          form={form}
          fieldId={FIELD_HANDLED_DATE}
          label={locales.alert_handled_date}
          initialValue={handledDate}
          required={false}
          showTime={false}
          format={MOMENT_DATE_FORMAT}
        />
        <SubmitCancelFormItem onSubmit={this.onFormSubmit} onCancel={this.onFormCancel}/>
      </Form>
    );
  }

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };

  private onFormSubmit = () => {
    const {form, onFormSubmit} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onFormSubmit(values[FIELD_HANDLED_DATE]);
      }
    });
  };
}

export default Form.create<Props>()(HandleAlertsForm);



// WEBPACK FOOTER //
// ./src/alerts/HandleAlertsForm.tsx